import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { vueEnv } from "@/config/vueEnv";

function webConfig() {
  return {
    apiKey: vueEnv("VUE_APP_FIREBASE_API_KEY"),
    authDomain: vueEnv("VUE_APP_FIREBASE_AUTH_DOMAIN"),
    projectId: vueEnv("VUE_APP_FIREBASE_PROJECT_ID"),
    storageBucket: vueEnv("VUE_APP_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: vueEnv("VUE_APP_FIREBASE_MESSAGING_SENDER_ID"),
    appId: vueEnv("VUE_APP_FIREBASE_APP_ID"),
  };
}

/** True when Firebase Web SDK can be initialized (Vue CLI: VUE_APP_FIREBASE_*). */
export function isFirebaseWebConfigured() {
  const c = webConfig();
  return !!(c.apiKey && c.authDomain && c.projectId && c.messagingSenderId);
}

let firebaseApp;

/** Google popup via Firebase Auth; returns Firebase ID token for POST /api/auth/google body.credential */
export async function signInWithGoogleAndGetIdToken() {
  if (!isFirebaseWebConfigured()) {
    throw new Error("Firebase web is not configured");
  }
  const cfg = webConfig();
  const appConfig = {
    apiKey: cfg.apiKey,
    authDomain: cfg.authDomain,
    projectId: cfg.projectId,
    messagingSenderId: cfg.messagingSenderId,
  };
  if (cfg.storageBucket) appConfig.storageBucket = cfg.storageBucket;
  if (cfg.appId) appConfig.appId = cfg.appId;

  if (!getApps().length) {
    firebaseApp = initializeApp(appConfig);
  } else if (!firebaseApp) {
    firebaseApp = getApps()[0];
  }
  const auth = getAuth(firebaseApp);
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result.user.getIdToken();
}
